import { NavLink } from "react-router-dom";
import { logout } from "../hooks/authConfig";
import NavLinkItem from "./NavLinkItem";
import logo from "../assets/logo.png";
import Dashboard from "../assets/icons/Dashboard.svg";
import Incidents from "../assets/icons/Incidents.svg";
import Changes from "../assets/icons/Changes.svg";
import Licenses from "../assets/icons/Licenses.svg";
import Invoices from "../assets/icons/business-finance-invoice-svgrepo-com.svg";
import Customers from "../assets/icons/Customers.svg";
import Times from "../assets/icons/Times.svg";
import Logout from "../assets/icons/logout-svgrepo-com (1).svg";
import Management from "../assets/icons/management.svg";
import project from "../assets/icons/project-svgrepo-com.svg";
import useUserInfo from "../hooks/useUserInfo";

const Sidebar = ({ isSidebarOpen }: { isSidebarOpen: boolean }) => {
  const { userInfo } = useUserInfo();

  if (
    userInfo.jobTitle === "Developer" ||
    userInfo.jobTitle === "Eigenaar / IT Consultant"
  ) {
    return (
      <aside
        className={`w-64 flex flex-col p-4 transition-transform duration-300 ease-in-out fixed z-30 select-none ${
          isSidebarOpen ? "transform-none" : "-translate-x-full"
        }`}
        style={{ top: 0, left: 0, bottom: 0 }}
      >
        {/* Logo */}
        <NavLink to="/" className="mb-3">
          <img src={logo} className="h-16 w-auto" alt="YouName-IT logo" />
        </NavLink>

        {/* Nav items */}
        <ul className="space-y-2">
          <NavLinkItem to="/" icon={Dashboard} label="Dashboard" />
          <NavLinkItem to="/incidents" icon={Incidents} label="Meldingen" />
          <NavLinkItem to="/changes" icon={Changes} label="Wijzigingen" />
          <NavLinkItem to="/licenses" icon={Licenses} label="Licenties" />
          <NavLinkItem to="/invoices" icon={Invoices} label="Factures" />
          <NavLinkItem to="/projects" icon={project} label="Projecten" />
          <NavLinkItem to="/management" icon={Management} label="Management" />
          <NavLinkItem to="/customers" icon={Customers} label="Klanten" />
          <NavLinkItem to="/time" icon={Times} label="Tijd" />
        </ul>
        <div className="mt-auto border-t border-gray-200" />

        {/* Logout */}
        <button
          onClick={logout}
          className="hover:text-[#4BBFED] transition duration-300 py-3 px-6 rounded-lg flex items-center w-auto"
        >
          <img src={Logout} alt="Logout Icon" className="mr-3 h-6 w-6" />
          Uitloggen
        </button>
      </aside>
    );
  } else {
    return (
      <aside
        className={`w-64 flex flex-col p-4 transition-transform duration-300 ease-in-out fixed z-30 select-none ${
          isSidebarOpen ? "transform-none" : "-translate-x-full"
        }`}
        style={{ top: 0, left: 0, bottom: 0 }}
      >
        {/* Logo */}
        <NavLink to="/" className="mb-3">
          <img src={logo} className="h-16 w-auto" alt="YouName-IT logo" />
        </NavLink>

        {/* Nav items */}
        <ul className="space-y-2">
          <NavLinkItem to="/" icon={Dashboard} label="Dashboard" />
          <NavLinkItem to="/incidents" icon={Incidents} label="Meldingen" />
          <NavLinkItem to="/changes" icon={Changes} label="Wijzigingen" />
          <NavLinkItem to="/licenses" icon={Licenses} label="Licenties" />
          {/* <NavLinkItem to="/invoices" icon={Invoices} label="Factures" /> */}
          {/* <NavLinkItem to="/projects" icon={project} label="Projecten" /> */}
          <NavLinkItem to="/management" icon={Management} label="Management" />
          <NavLinkItem to="/customers" icon={Customers} label="Klanten" />
          <NavLinkItem to="/time" icon={Times} label="Tijd" />
        </ul>
        <div className="mt-auto border-t border-gray-200" />

        {/* Logout */}
        <button
          onClick={logout}
          className="hover:text-[#4BBFED] transition duration-300 py-3 px-6 rounded-lg flex items-center w-auto"
        >
          <img src={Logout} alt="Logout Icon" className="mr-3 h-6 w-6" />
          Uitloggen
        </button>
      </aside>
    );
  }
};

export default Sidebar;
